export const layerScrollableAreaHeight = '400px'
export const layerOverlayMinHeight = '435px' // Keep child modals height in sync with parent modal
